import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField,
    usePermissions,
    useResourceContext,
    EditButton,
    Filter,
    SearchInput,
    BooleanField
} from 'react-admin';
import { processPermissions, isAdminUser } from "../../common/roleUtils";

const ProgramFilter = (props) => (
    <Filter {...props} variant='outlined'>
        <SearchInput source='program_name' alwaysOn placeholder="Search by program name" />
        <SearchInput source='program_code' placeholder="Search by code" />
    </Filter>
);

export const ProgramList = props => {
    const { permissions } = usePermissions();
    const resource = useResourceContext();
    
    // Use utility function to process permissions with role-based restrictions
    const propsObj = processPermissions(permissions, resource);
    
    // Enable bulk actions only for admin users (role_id = 1)
    const allowBulkActions = isAdminUser();
    
    return (
        <React.Fragment>
            <List 
                title="List of Programs" 
                {...props} 
                {...propsObj}
                filters={<ProgramFilter />}
                sort={{ field: 'program_name', order: 'ASC' }}
            >
                <Datagrid rowClick={propsObj.hasEdit ? 'edit' : false} bulkActionButtons={allowBulkActions ? undefined : false}>
                    {propsObj.hasEdit && <EditButton />}
                    <TextField source="id" />
                    <TextField source="program_code" label="Code" />
                    <TextField source="program_name" label="Program Name" />
                    <TextField source="description" label="Description" />
                    <BooleanField source="is_active" label="Active" />
                </Datagrid>
            </List>
        </React.Fragment>
    )
}
